(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const krkCollectionHandles = [
    'krk-accessories',
    'krk-monitors',
    'krk-subwoofer',
    'shop-all-krk-products',
    'krk-headphones',
    'krk',
  ];

  document.addEventListener('DOMContentLoaded', () => {
    const pathName = window.location.pathname;

    /** Regex Pattern For KRK Collections With Language Prefix Without Market **/
    const krkPattern = new RegExp(`^(?:/(?:es|it|de|nl))?/collections/(?:${krkCollectionHandles.join('|')})/?$`);

    if (krkPattern.test(pathName)) {
      const link = document.createElement('a');
      link.href = 'https://www.krkmusic.com/';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.location.href = "https://www.gibson.com";
    };
  });

  } catch(e) { console.error(e); }
})();
})();
